import React, { useCallback } from "react";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

export function Search({
  setSearchString,
}: {
  setSearchString: (searchString: string) => void;
}) {
  const { t } = useTranslation();

  const searchStringSetter = useCallback(
    (value) => {
      setSearchString(value);
    },
    [setSearchString],
  );

  return (
    <div className="search box">
      <Input.Search
        onSearch={searchStringSetter}
        size="large"
        placeholder={t("translation:search")}
      />
    </div>
  );
}
